import { LoanParams } from 'app/models/loan-params'
import { LoanAmendmentState } from './reducer'

export const getLoanAmendments = (state: {
  loanAmendments: { loanAmendments: LoanParams[] }
}) => state.loanAmendments.loanAmendments

export const getLoanAmendment = (state: {
  loanAmendments: { loanAmendment: LoanParams }
}) => {
  return state.loanAmendments.loanAmendment
}

export const getLoanAmendmentsByFacility = (state: {
  loanAmendments: LoanAmendmentState
}) => state.loanAmendments.facilityLoanAmendments

export const getLoanAmendmentLoader = (state: {
  loanAmendments: LoanAmendmentState
}) => {
  return state.loanAmendments.isLoading
}

export const getFacilityLoanAmendmentLoader = (state: {
  loanAmendments: LoanAmendmentState
}) => {
  return state.loanAmendments.facilityLoanAmendments.loading
}
